import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { AuthApi, getToken, setToken } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [booting, setBooting] = useState(true);

  // Restore the session on load.
  useEffect(() => {
    if (!getToken()) { setBooting(false); return; }
    AuthApi.me()
      .then((d) => setUser(d.user))
      .catch(() => setToken(''))       // token expired / invalid
      .finally(() => setBooting(false));
  }, []);

  const requestOtp = useCallback((phone) => AuthApi.sendOtp(phone), []);

  const verifyOtp = useCallback(async (phone, otp, referralCode) => {
    const { token, user: me } = await AuthApi.verifyOtp(phone, otp, referralCode);
    setToken(token);
    setUser(me);
    return me;
  }, []);

  const updateProfile = useCallback(async (payload) => {
    const { user: me } = await AuthApi.updateProfile(payload);
    setUser(me);
    return me;
  }, []);

  const logout = useCallback(() => {
    setToken('');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, isLoggedIn: Boolean(user), booting, requestOtp, verifyOtp, updateProfile, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
